<template>
    <div id="customerTransfer">
        <!-- <van-nav-bar title="转让" fixed placeholder left-arrow>
      <a @click="$router.back()" slot="left">
        <i class="iconfont iconfanhuianniu"></i>
      </a>
    </van-nav-bar> -->
        <van-form ref="form" @submit="onSubmit" input-align="right">
            <van-field readonly clickable name="companyId" :value="form.companyName" label="公司" placeholder="选择公司>" @click="showCompany = true" :rules="[{ required: true, message: '请选择公司' }]" />
            <van-field readonly clickable name="storeId" :value="form.storeName" label="门店" placeholder="选择门店>" @click="showStore = true" :rules="[{ required: true, message: '请选择门店' }]" />
            <van-field readonly clickable name="receiptId" :value="form.receiptName" label="管家" placeholder="选择管家>" @click="showOwner = true" />
            <van-field v-model="form.remark" rows="2" autosize label="其他需求" type="textarea" maxlength="50" placeholder="请输入其他需求" show-word-limit />
            <div style="height:1.2rem"></div>
            <div class="btn">
                <van-button round block type="primary" :loading="saveLoad" :disabled="saveLoad" native-type="submit">保存</van-button>
            </div>
        </van-form>
        <!-- 公司 -->
        <van-popup v-model="showCompany" position="bottom">
            <van-picker show-toolbar :columns="companyList" value-key="simpleName" @confirm="changeCompany" @cancel="showCompany = false" />
        </van-popup>
        <!-- 门店 -->
        <van-popup v-model="showStore" position="bottom">
            <van-picker show-toolbar :columns="storeList" value-key="name" @confirm="changeStore" @cancel="showStore = false" />
        </van-popup>
        <!-- 管家 -->
        <van-popup v-model="showOwner" position="bottom">
            <van-picker show-toolbar :columns="ownerList" value-key="name" @confirm="item => { if(!item)return;form.receiptName=item.name;form.receiptId=item.id;showOwner=false }" @cancel="showOwner = false" />
        </van-popup>
    </div>
</template>

<script>
import { mapState } from "vuex";
import {
    requestPCCompany,
    requestCompanyStore,
    requestStoreOwner,
    requestCustomerTransfer,
    requestCustomerFTransfer
} from "@/api";
export default {
    name: "customerTransfer",
    data() {
        return {
            form: {
                remark: ""
            },
            saveLoad: false,
            showCompany: false,
            companyList: [],
            showStore: false,
            storeList: [],
            showOwner: false,
            ownerList: []
        };
    },
    computed: {
        ...mapState([
            "idTypeList",
            "destineList",
            "payList",
            "contractList",
            "customerList"
        ])
    },
    created() {
        this.form.id = this.$route.query.id;
        this.getPCCompany();
    },
    mounted() {},
    methods: {
        //公司下拉
        getPCCompany() {
            requestPCCompany()
                .then(res => {
                    this.companyList = res.data;
                })
                .catch(err => {
                    console.log(err);
                });
        },
        changeCompany(item) {
            this.form.companyName = item.name;
            this.form.companyId = item.id;
            this.form.storeName = "";
            this.form.storeId = "";
            this.form.receiptName = "";
            this.form.receiptId = "";
            //根据公司查门店
            requestCompanyStore(item.id).then(res => {
                this.storeList = res.data ? res.data : [];
            });
            this.showCompany = false;
        },
        changeStore(item) {
            if (!item) return;
            this.form.storeName = item.name;
            this.form.storeId = item.id;
            this.form.receiptName = "";
            this.form.receiptId = "";
            //根据公司查管家
            requestStoreOwner({
                companyId: this.form.companyId,
                storeId: this.form.storeId
            }).then(res => {
                this.ownerList = res.data ? res.data : [];
            });
            this.showStore = false;
        },
        onSubmit() {
            console.log(this.form);
            this.saveLoad = true;
            if (this.$route.query.from == "1") {
                requestCustomerFTransfer(this.form)
                    .then(res => {
                        this.saveLoad = false;
                        this.$toast.success({
                            message: "转让成功",
                            forbidClick: true,
                            onClose: () => {
                                this.$router.back();
                            }
                        });
                    })
                    .catch(err => {
                        this.saveLoad = false;
                    });
            } else {
                requestCustomerTransfer(this.form)
                    .then(res => {
                        this.saveLoad = false;
                        this.$toast.success({
                            message: "转让成功",
                            forbidClick: true,
                            onClose: () => {
                                this.$router.back();
                            }
                        });
                    })
                    .catch(err => {
                        this.saveLoad = false;
                    });
            }
        }
    },
    watch: {}
};
</script>
<style lang="scss" scoped>
@import "../common/scss/variable.scss";
/deep/.van-field__error-message {
    text-align: right;
}
.btn {
    width: 100%;
    position: fixed;
    bottom: 0;
    left: 0;
    border-radius: 0.1rem;
    overflow: hidden;
    display: flex;
    /deep/.van-button {
        margin-left: -1px;
        border: none;
        border-radius: 0;
        flex: 1;
        &:not(:last-child)::after {
            height: 50%;
            position: absolute;
            box-sizing: border-box;
            content: " ";
            pointer-events: none;
            right: 0;
            top: 50%;
            transform: translateY(-50%);
            border-right: 0.02667rem solid #ebedf0;
            z-index: 99;
        }
    }
    .font4 {
        width: 2.4rem;
    }
    .font3 {
        width: 1.8rem;
    }
    .font5 {
        width: 51%;
    }
    .font1 {
        width: 100%;
        margin-left: 0;
    }
}
</style>
